export const cssVariables = {
  headerHeightVar: '--data-grid-header-height',
  rootHeightVar: '--data-grid-root-height',
  footerHeightVar: '--data-grid-footer-height',
  rootWidthVar: '--data-grid-root-width',
  leftPinnedWidthVar: '--data-grid-left-pinned-width',
  rightPinnedWidthVar: '--data-grid-right-pinned-width',
} as const;
